import React, { useEffect, useState } from "react";
import { API_BASE } from "../helpers/api";

const ContactForm = () => {
  const [csrfToken, setCsrfToken] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  // Get CSRF cookie + token from API origin
  useEffect(() => {
    fetch(`${API_BASE}/csrf/`, {
      method: "GET",
      credentials: "include", // critical to store the csrftoken cookie on 1338
    })
      .then((res) => res.json())
      .then((data) => setCsrfToken(data.csrfToken))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const formData = new FormData(e.target);

    try {
      const res = await fetch(`${API_BASE}/contact/`, {
        method: "POST",
        headers: {
          "X-CSRFToken": csrfToken || "",   // use the token from state
        },
        body: formData,
        credentials: "include",             // send the cookie along
      });

      if (res.ok) {
        setSubmitted(true);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || "Submission failed.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  if (submitted) {
    return (
      <div className="text-center space-y-2 bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 p-6 rounded-md shadow-md">
        <div className="text-2xl font-semibold text-green-600 dark:text-green-400">
          Thank you!
        </div>
        <p>We'll be in touch soon.</p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100 p-6 rounded-md shadow-md">
      <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto space-y-6">
        {error && <div className="text-red-600 dark:text-red-400">{error}</div>}

        <input
          type="text" name="name" placeholder="Your name" required
          className="w-full px-4 py-3 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <input
          type="email" name="email" placeholder="Your email" required
          className="w-full px-4 py-3 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <textarea
          name="message" placeholder="Your message" required rows="5"
          className="w-full px-4 py-3 rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          className="w-full md:w-auto px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-md shadow transition-all"
          disabled={!csrfToken} // optional: block submit until token fetched
        >
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
